<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-10-23 10:41:05
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-10-23 10:41:16
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/orderQuery/details.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="form-container">
      <div class="el-descriptions-title">订单信息</div>
      <order-info :apply-info="info" :is-has-operation="false" />
    </div>
    <evaluative-info type="1" :info="info" />
    <supply-service-capability :info="info" type="1" is-details />
    <el-row class="form-container">
      <div class="el-descriptions-title">产品质量评价申请人信息</div>
      <apply-info :apply-info="info"></apply-info>
    </el-row>
    <div class="form-container">
      <div class="el-descriptions-title margin-b-20">发票信息详情</div>
      <invoice-detail-info :apply-id="$route.query.applyId" />
    </div>
    <div class="form-container">
      <div class="el-descriptions-title margin-b-20">发票邮寄信息</div>
      <invoice-address-info :apply-id="$route.query.applyId" />
    </div>
    <div>
      <eui-btn type="secondary" @click="onCancel">返 回</eui-btn>
    </div>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/ESorganization';
import bus from '@/components/common/bus';
import supplyServiceCapability from '../components/supplyServiceCapability';
import evaluativeInfo from '../components/evaluativeInfo';
import orderInfo from '../ESapply/component/orderInfo';
import applyInfo from '../ESapply/component/applyInfo.vue';
import invoiceDetailInfo from '../ESapply/component/invoiceDetailInfo.vue';
import invoiceAddressInfo from '../ESapply/component/invoiceAddressInfo.vue';

export default {
  name: 'EsOrderDetails',
  components: {
    eTableList,
    supplyServiceCapability,
    evaluativeInfo,
    orderInfo,
    applyInfo,
    invoiceAddressInfo,
    invoiceDetailInfo,
  },
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取基础信息
     */
    getData() {
      Api.getEvaluationApplyDetail({
        applyId: this.$route.query.applyId,
      }).then((res) => {
        if (res.code === '200') {
          this.info = res.data;
        }
      });
    },
    onCancel() {
      bus.$emit('close_current_tags');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../components/common';
</style>
